<template lang="pug">
    component(:is="tag")
        fa(icon="spinner")
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span"
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes SpinAnimation {
  100% {
    transform: rotate(360deg);
  }
}
svg {
  animation: SpinAnimation 1s ease-in-out infinite;
}
</style>